import {mapGetters} from "vuex";

export default {
    computed:{
        ...mapGetters(['couponData']),
        productPrice(){
            return (this.product.price * this.order.details.quantity);
        },
        packaging(){
            if(this.product.use_fixed_packaging_price){
                return (this.packaging_fee * this.order.details.quantity);
            }else{
                return (this.selectionsPackagingFeeTotal + this.extraSelectionsPackagingFeeTotal);
            }
        },
        energy(){
            if(this.energy_fee === null){
                return 0;
            }

            return (this.energy_fee * this.order.details.quantity);
        },
        premiumSelectionsPrice(){
            let selectedOptions = _.flatten(this.order.details.selections.map(item =>item.options)).filter(item => item.premium);

            if(selectedOptions.length === 0){
                return 0;
            }

            let options = _.flatten(this.product.selections.map(item => item.options));

            return selectedOptions.map(item => {
                return options.find(option => option.id === item.id).price * item.quantity;
            }).reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        extraSelectionsPrice(){
            let selectedExtraOptions = _.flatten(this.order.details.extra_selections.map(item =>item.options));

            if(selectedExtraOptions.length === 0){
                return 0;
            }

            let extraOptions = _.flatten(this.product.extra_selections.map(item => item.options));

            return selectedExtraOptions.map(item => {
               return extraOptions.find(option => option.id === item.id).as_extra_price * item.quantity;
            }).reduce((accumulator, currentValue) => accumulator + currentValue);

        },
        selectionsPackagingFeeTotal(){
            let selectedOptions = _.flatten(this.order.details.selections.map(item =>item.options));

            if(selectedOptions.length === 0){
                return 0;
            }

            let options = _.flatten(this.product.selections.map(item => item.options));

            return selectedOptions.map(item => {
                return options.find(option => option.id === item.id).packaging_price * item.quantity;
            }).reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        extraSelectionsPackagingFeeTotal(){
            let selectedExtraOptions = _.flatten(this.order.details.extra_selections.map(item =>item.options));

            if(selectedExtraOptions.length === 0){
                return 0;
            }

            let extraOptions = _.flatten(this.product.extra_selections.map(item => item.options));

            return selectedExtraOptions.map(item => {
                return extraOptions.find(option => option.id === item.id).packaging_price * item.quantity;
            }).reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        total(){
            if(this.order.delivery.delivery_fee > 0){
                return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice + this.order.delivery.delivery_fee;
            }
            
            return this.productPrice + this.packaging + this.energy + this.premiumSelectionsPrice + this.extraSelectionsPrice
        },
        totalWithoutDeliveryFee(){
            return this.productPrice + this.packaging + this.energy + this.premiumSelectionsPrice + this.extraSelectionsPrice;
        },
        totalWithoutPackaging(){
            if(this.order.delivery.delivery_fee > 0){
                return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice + this.order.delivery.delivery_fee;
            }
            return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice
        },
        discount(){
            return {
                productPrice: this.calculateDiscount(this.productPrice),
                packaging: this.calculateDiscount(this.packaging),
                energy: this.calculateDiscount(this.energy),
                premiumSelectionsPrice: this.calculateDiscount(this.premiumSelectionsPrice),
                extraSelectionsPrice: this.calculateDiscount(this.extraSelectionsPrice),
                totalWithoutDeliveryFee: this.calculateDiscount(this.totalWithoutDeliveryFee, true),
                total: (this.totalWithoutDeliveryFee - this.calculateDiscount(this.totalWithoutDeliveryFee)) + this.order.delivery.delivery_fee,
                text: this.createDiscountText(),
            }
        }
    },
    methods:{
        selectionHasPremiumSelected(selection){
            return selection.options.filter(item => item.premium).length > 0;
        },
        selectionSelectedPremiumOptionsTotal(selection){
            return selection.options.filter(item => item.premium).map(item => item.price * item.quantity).reduce((acc, cur) => acc + cur);
        },
        selectionSelectedExtraOptionsTotal(selection){
            return selection.options.map(item => item.as_extra_price * item.quantity).reduce((acc, cur) => acc + cur);
        },
        calculateDiscount(amount, useDifference){
            if(!this.couponData){
                return 0;
            }

            if(this.couponData.in_percent){
                const percentage = this.couponData.value / 100;
                return amount * percentage;
            }


            const discount = amount - this.couponData.value;

            if(discount < 0){
                return amount;
            }

            return amount - discount;
        },
        createDiscountText(){
            if(!this.couponData){
                return;
            }

            if(this.couponData.in_percent){
                return `${this.couponData.value}%`;
            }

            return this.couponData.value;
        }
    }
}
